import { request } from "./client";

export const getLeaderboard = () =>
  request("/leaderboard")
    .then((data) => ({
      top20: data?.top ?? [],
      currentUser: data?.currentUser ?? null,
      updatedAt: data?.updatedAt ?? null,
    }))
    .catch(() => ({ top20: [], currentUser: null, updatedAt: null }));

// Separate ranking from getLeaderboard() — only includes profiles with an
// active stake, rather than re-sorting the CIS top-20 (which could show
// non-stakers at 0 CLT, and could never show a real staker outside the
// CIS top-20).
export const getTopStakers = () =>
  request("/leaderboard/stakers")
    .then((res) => (Array.isArray(res?.data) ? res.data : []))
    .catch(() => []);

export const getMyLeaderboardStats = () => Promise.resolve(null);
